import repository from './repository'

const resource = 'account-codes'

export default {
  index (params) {
    return repository.get(resource, { params })
  },
  store (data) {
    return repository.post(resource, data)
  },
  update (id, data) {
    return repository.put(`${resource}/${id}`, data)
  },
  parent (params) {
    return repository.get(`${resource}/parents`, { params })
  },
  children (params) {
    return repository.get(`${resource}/children`, { params })
  },
}
